/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * An enumeration.
 * @export
 * @enum {string}
 */
export enum ExternalDeviceType {
    RefrigeratorUnit = 'refrigerator_unit',
    TemperatureSensor = 'temperature_sensor',
    TrailerId = 'trailer_id',
    TrailerManual = 'trailer_manual'
}

export function ExternalDeviceTypeFromJSON(json: any): ExternalDeviceType {
    return ExternalDeviceTypeFromJSONTyped(json, false);
}

export function ExternalDeviceTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalDeviceType {
    return json as ExternalDeviceType;
}

export function ExternalDeviceTypeToJSON(value?: ExternalDeviceType | null): any {
    return value as any;
}

